import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import FooterAnimated from "./FooterAnimated";

export default function Layout() {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1  p-6">
        <Outlet /> {/* route content loads here */}
      </main>
      <FooterAnimated />
    </div>
  );
}
